export default function () {
  return {
    searchlimits: [],
    searchlimitsCurrentPage: 1,
    searchlimitsLastPage: 1,
    searchlimitsPerPage: 0,
    searchlimitsTotal: 0,
    searchlimitsLoading: false,
    todaylimitsLoading: false,
    indexPage: null
  }
}
